import { render } from "./NeuroMedicine.vue?vue&type=template&id=ee6d27c8&scoped=true"
import script from "./NeuroMedicine.vue?vue&type=script&lang=ts"
export * from "./NeuroMedicine.vue?vue&type=script&lang=ts"

import "./NeuroMedicine.vue?vue&type=style&index=0&id=ee6d27c8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ee6d27c8"

export default script